import type { CSSProperties } from "react";
import type { Card as PbCard } from "../gen/bazivan/v1/table_pb";
import { isRed, rankLabel, suitSymbol } from "../game/cards";

/** کارت‌های ویژه‌ی هفت خبیث — همان ترتیبِ Bazivan.Core.Special. */
export const specialName: Record<number, string> = { 1: "آینه", 2: "بمب", 3: "سپر", 4: "پنهان" };
const specialGlyph: Record<number, string> = { 1: "◈", 2: "✸", 3: "⛨", 4: "◌" };

type Props = {
  card?: PbCard;
  /** کارتِ ویژه (۱ تا ۴) — بی‌خال و بی‌رتبه، صورتِ خودش را دارد. */
  special?: number;
  faceDown?: boolean;
  width?: number;
  dim?: boolean;
  picked?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
  className?: string;
};

/**
 * یک ورق.
 *
 * پایه‌اش DOM است (بی‌تصویر، بی‌درنگ)، ولی وقتی آرتِ میز رسید — کلاسِ `art` روی
 * <html> — همین گره صورتِ واقعیِ ورق را از اسپرایت می‌گیرد. جای هر ورق در
 * اسپرایت از خودِ enum پروتکل درمی‌آید: ستون = رتبه‌ی منهای یک، ردیف = خال
 * منهای یک (HEARTS=1 … CLUBS=4)، پس جدولِ جداگانه‌ای لازم نیست که از پروتکل
 * جا بمانَد.
 */
export function CardView({ card, special, faceDown, width = 58, dim, picked, onClick, style, className }: Props) {
  const cls = [
    "card",
    faceDown ? "back" : "",
    special ? `special sp${special}` : "",
    !faceDown && card && isRed(card.suit) ? "red" : "",
    dim ? "dim" : "",
    picked ? "pick" : "",
    onClick ? "playable" : "",
    className ?? "",
  ].filter(Boolean).join(" ");

  // عرضِ کارت متغیرِ CSS است تا اندازه‌ی رتبه و خال از آن مشتق شود.
  const css = { ...style, "--cw": `${width}px` } as CSSProperties;
  if (!faceDown && card) {
    css["--col" as never] = String(card.rank - 1) as never;
    css["--row" as never] = String(card.suit - 1) as never;
  }

  return (
    <div className={cls} style={css} onClick={onClick}>
      {!faceDown && special && (
        <span className="spf">
          <span className="g">{specialGlyph[special]}</span>
          <span className="n">{specialName[special]}</span>
        </span>
      )}
      {!faceDown && !special && card && (
        <>
          <span className="idx">
            <span className="r">{rankLabel(card.rank)}</span>
            <span className="s">{suitSymbol[card.suit]}</span>
          </span>
          <span className="pip">{suitSymbol[card.suit]}</span>
        </>
      )}
    </div>
  );
}
